import { render } from "./Claim2_Eval.vue?vue&type=template&id=69cdd25a&scoped=true"
import script from "./Claim2_Eval.vue?vue&type=script&lang=js"
export * from "./Claim2_Eval.vue?vue&type=script&lang=js"

import "./Claim2_Eval.vue?vue&type=style&index=0&id=69cdd25a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-69cdd25a"

export default script